import { Avatar } from '@mantine/core'
import type { Practitioner } from '@medplum/fhirtypes'
import { avatarColor, getInitials, getPractitionerName } from '../presentation'

type ParticipantAvatarProps = {
  practitioner?: Practitioner
  size?: number
  className?: string
}

/**
 * A practitioner's photo where one is recorded, initials on a stable color
 * otherwise. Decorative — every caller renders the participant's name as text
 * alongside it, so it is hidden from assistive tech rather than repeating it.
 */
export const ParticipantAvatar = ({
  practitioner,
  size = 40,
  className,
}: ParticipantAvatarProps) => {
  const name = getPractitionerName(practitioner)
  const photoUrl = practitioner?.photo?.[0]?.url

  return (
    <Avatar
      src={photoUrl}
      size={size}
      radius="xl"
      aria-hidden
      className={className}
      style={{ backgroundColor: photoUrl ? undefined : avatarColor(practitioner?.id ?? name) }}
      styles={{ placeholder: { backgroundColor: 'transparent' } }}
    >
      {/* Floored so the initials stay legible in the row grid's ~19px tiles,
          where the proportional size would land at 6px. No effect above 28px. */}
      <span
        className="font-semibold text-white"
        style={{ fontSize: Math.max(9, Math.round(size * 0.32)) }}
      >
        {getInitials(name)}
      </span>
    </Avatar>
  )
}
